module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ja":{"confirmation":"確認","no":"いいえ","yes":"はい"},"en":{"no":"No","yes":"Yes","confirmation":"Confirmation"}}')
  delete Component.options._Ctor
}
